import React, { Component } from "react";
//// componentes reutilizables
import MensajeUsuario from "../../generico/MensajeUsuario";
import AuthService from '../../../services/login/auth.service';
import Titulo from "../../generico/TituloPagina";
import history from "./history";
import $ from "jquery";
import DatosSocio from "../../generico/DatosSocio";
import Popup from "react-popup";
import { isDesktopOrLaptop } from "../../generico/utils/TamanhoPantalla";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";


export default class PinTransaccional extends Component {

    constructor(props) {
        super(props);
        this.onChangePinAnterior = this.onChangePinAnterior.bind(this);
        this.guardar = this.guardar.bind(this);
        this.limpiarDatos = this.limpiarDatos.bind(this);
        this.limpiarPinConfirmacion = this.limpiarPinConfirmacion.bind(this);
        this.limpiarNuevoPin = this.limpiarNuevoPin.bind(this);
        this.limpiarUnNuevoPin = this.limpiarUnNuevoPin.bind(this);
        this.limpiarUnPinConfirmacion = this.limpiarUnPinConfirmacion.bind(this);
        this.state = {
            pinAnterior: "",
            numeros: this.cargar(),
            confirma: this.cargar(),
            pinNuevo: "",
            pinConf: "",
            loading: false,
            showBox: false,
            showBoxConf: false,
            message: ""
        };

    }

    limpiarDatos() {


        this.setState({
            pinAnterior: "",
            pinNuevo: "",
            pinConf: ""
        });

    }
    limpiarNuevoPin() {
        this.setState({
            pinNuevo: ""
        });

    }
    limpiarPinConfirmacion() {
        this.setState({
            pinConf: ""
        });

    }
    limpiarUnNuevoPin() {
        this.setState({
            pinNuevo: this.state.pinNuevo.slice(0,-1)
        });

    }
    limpiarUnPinConfirmacion() {
        this.setState({
            pinConf: this.state.pinConf.slice(0,-1)
        });

    }
    handleClick = value => () => {
        if (this.state.pinNuevo.length >= 6) {
            return
        }
        this.setState({
            pinNuevo: this.state.pinNuevo + this.state.numeros[value],
            showBox: isDesktopOrLaptop(), //true,
            numeros: this.cargar()
        });
    };

    handleClickConfirmar = value => () => {
        this.setState({
            pinConf: this.state.pinConf + this.state.confirma[value],
            showBoxConf: isDesktopOrLaptop(), //true,,
            confirma: this.cargar()
        });
    };


    onChangePinAnterior(e) {

        $(document).ready(function () {

            $(".input-box").keypress(function (e) {

                if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {

                    $("#errmsg").html("Solo valores numéricos").show().fadeOut("slow");
                    return false;
                }

            });
        });
        this.setState({
            pinAnterior: e.target.value
        });
    }

    handleBoxToggle = () => {
        if(isDesktopOrLaptop()){
            this.setState({ showBox: !this.state.showBox });
        }
    } 
    handleBoxOut = () => {
        if(isDesktopOrLaptop()){
            this.setState({ showBox: !this.state.showBox });
        }
    }
    handleBoxToggleConf = () => {
        if(isDesktopOrLaptop()){
            this.setState({ showBoxConf: !this.state.showBoxConf });
        }
    } 
    handleBoxOutConf = () => {
        if(isDesktopOrLaptop()){
            this.setState({ showBoxConf: !this.state.showBoxConf });
        }
    }


    componentDidMount() {

    }
    cargar() {
        var _valores = [];
        for (var i = 0; i < 10; i++) {
            _valores[i] = i;
        }
        for (let i = _valores.length - 1; i > 0; i--) {
            let indiceAleatorio = Math.floor(Math.random() * (i + 1));
            let temporal = _valores[i];
            _valores[i] = _valores[indiceAleatorio];
            _valores[indiceAleatorio] = temporal;
        }
        return _valores

    };



    guardar(e) {
        e.preventDefault();
        var msg = "";
        this.btn.setAttribute("disabled", "disabled");  
        this.setState({
            message: msg,
            loading: true,
        });
        if(this.state.pinAnterior.length < 1 ){
            msg = "Debe completar el pin anterior"
            this.setState({
                message: msg,
                loading: false
            });
            this.btn.removeAttribute("disabled");
            return
        }
        if (this.state.pinNuevo.length > 6 && this.state.pinNuevo.length < 6) {
            msg = "El pin debe tener 6 caracteres"
            this.setState({
                message: msg,
                loading: false
            });
            this.btn.removeAttribute("disabled");
            return
        }
        var iguales = false;
        if (this.state.pinNuevo === this.state.pinConf)
            iguales = true;
        if (!iguales) {
            msg = "No coinciden los pines ingresados"
            this.setState({
                message: msg,
                loading: false
            });
            this.btn.removeAttribute("disabled");
            return
        }

        AuthService.confirmarCambioPinTransaccional(this.state.pinAnterior, this.state.pinNuevo).then(
            (response) => {
                var jsonData = JSON.parse(response);
                this.setState({
                    loading: false,
                });
                if (jsonData.codigoRetorno === '0') {
                    sessionStorage.removeItem('pinTransaccional')
                    Popup.queue(this.notifiPopupOk("Info", "Datos actualizados correctamente. Será redireccionado a la pantalla principal."));
                } else {
                    this.btn.removeAttribute("disabled");
                    Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
                    return;
                    
                }
            },
            error => {
                const resMessage = error.response;

                this.setState({
                    loading: false,
                    message: resMessage
                });
            }
        );

    }
    notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });
  
  notifiPopupOk = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
            //history.push('/resumenGeneralSocio')
            history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
            window.location.reload();
          },
        },
      ],
    },
  });

    render() {
        setTimeout(() => {
            var elemento = $(".content-wrapper")[1];
            if(elemento!== undefined){
                elemento.remove();
            }
        }, 100);
        return (
            <div className="content-wrapper">
                <Titulo texto="Cambiar PIN - Transferencia Interbancaria" />
                <section className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <MensajeUsuario tipo="INFO"
                                    titulo="¡Importante!"
                                    mensaje="Usted tiene que realizar el cambio del pin transaccional" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <DatosSocio />
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="callout callout-warning consideraciones">
                                                    <h5>Consideraciones</h5>
                                                    <p>Recuerde que su pin es exclusivamente para su uso personal, y que la misma sustituye a su firma,
                                                    siendo de su entera responsabilidad el uso de la misma. No la divulgue.
                                                    Eximo a la Universitaria Ltda. de toda responsabilidad y/o
                                                reclamo que pudiere surgir eventualmente por las operaciones realizadas.</p>
                                                </div>
                                                {this.state.message && (
                                                    <div className="form-group">
                                                        <div className="alert alert-danger" role="alert">
                                                            {this.state.message}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-md-6" style={{ paddingLeft: 20 }}>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <label className="input-label-bold">Pin Anterior (6 dígitos) *</label>
                                                            <input id="pinOld" type="password" className="input-box form-control" name="pinAnterior"
                                                                maxLength={6}
                                                                onChange={this.onChangePinAnterior}
                                                                value={this.state.pinAnterior}
                                                                required
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 d-flex justify-content-center">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label className="input-label">Nuevo Pin (6 dígitos) *</label>
                                                                    <input type="password" className="input-color input-box form-control" value={this.state.pinNuevo} disabled />
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="container" style={{ width: '80%' }} onMouseOver={this.handleBoxToggle} onMouseOut={this.handleBoxOut}>
                                                                    <div className="row">
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('0')}> {this.state.showBox ? '*' : this.state.numeros[0]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('1')}>{this.state.showBox ? '*' : this.state.numeros[1]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('2')}>{this.state.showBox ? '*' : this.state.numeros[2]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('3')}>{this.state.showBox ? '*' : this.state.numeros[3]} </a></div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('4')}>{this.state.showBox ? '*' : this.state.numeros[4]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('5')}>{this.state.showBox ? '*' : this.state.numeros[5]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('6')}>{this.state.showBox ? '*' : this.state.numeros[6]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('7')}>{this.state.showBox ? '*' : this.state.numeros[7]} </a></div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('8')}>{this.state.showBox ? '*' : this.state.numeros[8]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClick('9')}>{this.state.showBox ? '*' : this.state.numeros[9]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.limpiarUnNuevoPin}><i className="fas fa-chevron-left" /></a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.limpiarNuevoPin}><i className="fas fa-trash" /></a></div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 d-flex justify-content-center">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <label className="input-label">Confirmar Pin (6 dígitos) *</label>
                                                                    <input type="password" className="input-color input-box form-control" value={this.state.pinConf} disabled />
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="container" style={{ width: '80%' }} onMouseOver={this.handleBoxToggleConf} onMouseOut={this.handleBoxOutConf}>
                                                                    <div className="row">
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('0')}> {this.state.showBoxConf ? '*' : this.state.confirma[0]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('1')}>{this.state.showBoxConf ? '*' : this.state.confirma[1]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('2')}>{this.state.showBoxConf ? '*' : this.state.confirma[2]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('3')}>{this.state.showBoxConf ? '*' : this.state.confirma[3]} </a></div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('4')}>{this.state.showBoxConf ? '*' : this.state.confirma[4]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('5')}>{this.state.showBoxConf ? '*' : this.state.confirma[5]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('6')}>{this.state.showBoxConf ? '*' : this.state.confirma[6]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('7')}>{this.state.showBoxConf ? '*' : this.state.confirma[7]} </a></div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('8')}>{this.state.showBoxConf ? '*' : this.state.confirma[8]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.handleClickConfirmar('9')}>{this.state.showBoxConf ? '*' : this.state.confirma[9]} </a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.limpiarUnPinConfirmacion}><i className="fas fa-chevron-left" /></a></div>
                                                                        <div className="btn-teclado-contenedor"><a className="btn btn-default btn-teclado" onClick={this.limpiarPinConfirmacion}><i className="fas fa-trash" /></a></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="card-footer"> 
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                        <label className="input-label-bold-obligatorio float-left">
                                            (*) Campos Obligatorios
                                        </label>
                                        </div>
                                        <div className="col-md-3 col-12">
                                        <button ref={btn => { this.btn = btn; }} type="submit" className="btn btn-cu-primary float-right" onClick={this.guardar}>
                                            {this.state.loading && (<span className="spinner-border spinner-border-sm"></span>)}Guardar
                                        </button>
                                        </div>
                                        <div className="col-md-3 col-12">
                                        <button type="submit" className="btn btn-cu-quintary float-right" onClick={this.limpiarDatos} >Limpiar Todo</button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}